/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersonnelRequest } from '../models/PersonnelRequest';
import type { PersonnelResource } from '../models/PersonnelResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PersonnelService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les personnels actifs
     * Avec la date de derniere connexion de chacun. Les personnels desactives n'apparaissent pas.
     * @returns PersonnelResource Array of `PersonnelResource`
     * @throws ApiError
     */
    public personnelsIndex(): CancelablePromise<Array<PersonnelResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/personnels',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Creer un personnel
     * Les roles se definissent ensuite par une modification (`ROLES`).
     * @param requestBody
     * @returns PersonnelResource `PersonnelResource`
     * @throws ApiError
     */
    public personnelsStore(
        requestBody?: PersonnelRequest,
    ): CancelablePromise<PersonnelResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/personnels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un personnel
     * Avec ses roles.
     * @param id
     * @returns PersonnelResource `PersonnelResource`
     * @throws ApiError
     */
    public personnelsShow(
        id: string,
    ): CancelablePromise<PersonnelResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/personnels/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Modifier un personnel
     * Si `ROLES` est envoye, il **remplace** l'ensemble des roles du personnel.
     * @param id
     * @param requestBody
     * @returns PersonnelResource `PersonnelResource`
     * @throws ApiError
     */
    public personnelsUpdate(
        id: string,
        requestBody?: PersonnelRequest,
    ): CancelablePromise<PersonnelResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/personnels/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un personnel
     * Reponse : `{ message }`.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public personnelsDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/personnels/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Envoyer le mail d'installation de Lol@pp
     * Envoie au personnel `IDPERSONNEL` les instructions d'installation de l'application, a l'adresse `email` si elle est fournie, sinon a celle de sa fiche. Reponse : `{ status: "sent" }`.
     * @param idpersonnel
     * @param email
     * @returns any
     * @throws ApiError
     */
    public personnelSendInstallationMail(
        idpersonnel: number,
        email?: string | null,
    ): CancelablePromise<{
        status: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/send_installation_mail',
            query: {
                'IDPERSONNEL': idpersonnel,
                'email': email,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Lister les personnels actifs
     * Avec la date de derniere connexion de chacun. Les personnels desactives n'apparaissent pas.
     * @returns PersonnelResource Array of `PersonnelResource`
     * @throws ApiError
     */
    public adminPersonnelsIndex(): CancelablePromise<Array<PersonnelResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/personnels',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Creer un personnel
     * Les roles se definissent ensuite par une modification (`ROLES`).
     * @param requestBody
     * @returns PersonnelResource `PersonnelResource`
     * @throws ApiError
     */
    public adminPersonnelsStore(
        requestBody?: PersonnelRequest,
    ): CancelablePromise<PersonnelResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/personnels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un personnel
     * Avec ses roles.
     * @param id
     * @returns PersonnelResource `PersonnelResource`
     * @throws ApiError
     */
    public adminPersonnelsShow(
        id: string,
    ): CancelablePromise<PersonnelResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/personnels/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Modifier un personnel
     * Si `ROLES` est envoye, il **remplace** l'ensemble des roles du personnel.
     * @param id
     * @param requestBody
     * @returns PersonnelResource `PersonnelResource`
     * @throws ApiError
     */
    public adminPersonnelsUpdate(
        id: string,
        requestBody?: PersonnelRequest,
    ): CancelablePromise<PersonnelResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/personnels/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un personnel
     * Reponse : `{ message }`.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminPersonnelsDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/personnels/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Deconnecter un personnel de tous ses appareils
     * Tous ses tokens sont revoques ; il devra se reconnecter. Reponse : `{ message, revoked_count }`.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public personnelRevokeTokens(
        id: string,
    ): CancelablePromise<{
        message: string;
        revoked_count: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/personnels/{id}/tokens',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
